import React, { } from 'react';
import { Box, Image, Text } from '@chakra-ui/react'

import BaseModal from '../GlobalComponents/BaseModal';

export default function ImageBox(props) {

    return (
        <BaseModal isOpen={props.isOpen} onClose={() => props.ImageCall()}
            style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '500px', minHeight: '250px', maxHeight: '80%', padding: 3, overflow: 'auto' }}
        >
            <Box style={{ display: 'flex', margin: 5 }}>
                <Text fontSize={25} fontWeight='bold' padding={1}>Zugestellt an: </Text>
                <Text fontSize={25} border='0.5px solid gray' padding={1} ml={3}>{props.curentReci}</Text>
            </Box>

            <Box display='flex' flex={1} height='100%' flexDirection='column' justifyContent='center' p={0} overflowY="auto">

                {props.ImageUri.map((item) => (

                    <Box borderWidth={3} margin={1} key={item.uri} w='17vw'>
                        {/*<Image src={props.server + '/API/tmp/' + item.uri} alt={item.uri} objectFit='contain' />*/}
                        {item.uri && item.uri !== null ? (
                            <a href={props.server + '/API/' + props.ImageDir + item.uri} target="_blank">
                                <Image
                                    src={props.server + '/API/' + props.ImageDir + item.uri}
                                    alt={item.uri}
                                    objectFit='contain'
                                />
                            </a>

                        ) : (
                            <Text fontSize={20} >Kein Bild hinterlegt!</Text>
                        )}
                    </Box>
                ))}
            </Box>
        </BaseModal>
    );
}